import Share from './main.js';
export default Share;
